import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8.442 12.376a.667.667 0 0 1-.88.056l-.062-.056-4.461-4.471 4.46-4.471a.667.667 0 0 1 .88-.056l.063.056c.24.24.26.618.056.88l-.056.062-2.868 2.862h6.72a.667.667 0 1 1 0 1.334H5.563l2.88 2.862c.24.24.26.618.056.88l-.056.062z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}